<template>
  <div
    class="flex items-center overflow-y-auto rounded-b-r2 border border-solid border-t-action bg-neutral-50 shadow-md"
    :class="{
      'flex-wrap': (brands?.length ?? 0) > 9,
      'flex-col': (brands?.length ?? 0) <= 9,
    }"
  >
    <MenuItem
      v-for="brand in brands"
      v-bind="brand"
      class="w-[150px]"
      @click="$emit('select', brand.q_key, brand.value)"
    />
  </div>
</template>

<script setup lang="ts">
import type { NavItemProps } from "~/types/schemas/informative/Molecule/NavItem";
import MenuItem from "~/components/informative/Atom/MenuItem.vue";

defineEmits<{
  select: [key: string, value: string];
}>();

defineProps<{
  brands?: NavItemProps[];
}>();
</script>
